import React from "react";
import TextField from "@mui/material/TextField";
import "../../Styles/Creator_Form/basicinfo.css";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import mobile from "./mobile";

const Basicinfo = ({
  setValues = (f) => f,
  setMenu = (f) => f,
  handleChange = (f) => f,
  values,
}) => {
  const names = [
    "English",
    "Hindi",
    "Marathi",
    "Konkani",
    "Bengali",
    "Tamil",
    "Kannada",
    "German",
    "Chinese",
    "Telugu",
  ];

  const handleLanguage = (event) => {
    const {
      target: { value },
    } = event;

    setValues({
      ...values,
      languages: typeof value === "string" ? value.split(",") : value,
    });
  };

  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250,
      },
    },
  };

  return (
    <div>
      <div className="basic">
        <div className="inputfields">
          <TextField
            label="Full Name"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("name")}
            value={values.name}
          />
        </div>
        <InputLabel id="demo-multiple-checkbox-label">Phone Number:</InputLabel>
        <div className="inputfields phoneinput">
          <div className="phoneinput">
            <input
              value={values.mobile}
              onChange={handleChange("mobile")}
              type="number"
            />
            <select
              onChange={handleChange("statusCode")}
              value={values.statusCode}
              defaultValue="0"
            >
              <option value="0">Choose</option>
              {mobile.map((item) => (
                <option key={item.dial_code} value={item.dial_code}>
                  {item.code}+{item.dial_code}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className="inputfields">
          <TextField
            label="Email"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("email")}
            value={values.email}
          />
        </div>
        <div className="inputfields">
          <TextField
            id="outlined-multiline-static"
            label="Password"
            type="Password"
            onChange={handleChange("password")}
            value={values.password}
          />
        </div>

        <div className="inputfields">
          <TextField
            label="Location"
            type="Artist Name"
            id="outlined-size-small"
            onChange={handleChange("location")}
            value={values.location}
          />
        </div>
        <div className="inputfields checkboxselect">
          <InputLabel id="demo-multiple-checkbox-label">Languages:</InputLabel>
          <Select
            labelId="demo-multiple-checkbox-label"
            id="demo-multiple-checkbox"
            multiple
            value={values.languages}
            onChange={handleLanguage}
            input={<OutlinedInput label="Languages" />}
            renderValue={(selected) => selected.join(", ")}
            MenuProps={MenuProps}
          >
            {names.map((name) => (
              <MenuItem key={name} value={name}>
                <Checkbox checked={values.languages.indexOf(name) > -1} />
                <ListItemText primary={name} />
              </MenuItem>
            ))}
          </Select>
        </div>
        <div className="biginput">
          <TextField
            id="outlined-multiline-static"
            label="Describe Yourself"
            multiline
            rows={4}
            onChange={handleChange("shortdescription")}
            value={values.shortdescription}
          />
        </div>
        <div className="nextbut">
          <button
            disabled={
              !values.name ||
              !values.email ||
              !values.password ||
              !values.location ||
              !values.statusCode ||
              !values.mobile ||
              !values.shortdescription ||
              values.languages.length === 0
                ? true
                : false
            }
            onClick={() => setMenu("second")}
          >
            Next
          </button>
        </div>
      </div>
    </div>
  );
};

export default Basicinfo;
